module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/calculator-ca14b404bd20ba95c303c51977c58c16.svg";